import React, { useEffect} from 'react';
import {
  ChakraProvider,
  Box,
  Image,
  Heading,
  Text,
  VStack,
  HStack,
  IconButton,
  Link,
  useColorMode,
  useColorModeValue,
  Container,
  Flex
} from '@chakra-ui/react';
import { FaSun, FaMoon, FaGithub, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa';
import GitHubCalendar from 'react-github-calendar';
import Sidebar from './components/Sidebar.js';
import About from './components/About.js';
import Education from './components/Education.js';
import Projects from './components/Projects.js';
import Resume from './components/Resume.js';
import Certifications from './components/Certifications.js';
import Contact from './components/Contact.js';
import AnimatedSkillIconBar from './components/AnimatedSkillsIconBar.js';


import perrchatGif from "./gif/peerchat.gif";
import tasktonicGif from "./gif/tasktonic.gif";
import bloomroomGif from "./gif/bloomroom.gif";


const projects = [
  {
    title: 'Projects PeerChat',
    description: 'WebRTC, Socket.io, Express.js • Developed a real-time chat application with video and file sharing (up to 255MB) capabilities. • Implemented a signaling server using Socket.io and Express.js. • Incorporated desktop window sharing feature for enhanced user interaction.',
    technologies: ['WebRTC', 'Socket.io', 'Express.js'],
    liveUrl: 'https://peer-chat-nine.vercel.app/',
    frontendUrl: 'https://github.com/suiisharma/PeerChat',
    backendUrl: 'https://github.com/suiisharma/PeerChatServer',
    previewGif: perrchatGif
  },
  {
    title: 'TaskTonic',
    description: 'Node.js, React, Chakra UI, MongoDB • Developed a personal task management application to streamline workflows and improve productivity. • Incorporated email verification for improved security using Nodemailer and developed features for efficient task allocation, resulting in a 6-32% reduction in personal paper usage.',
    technologies: ['Node.js', 'React', 'Chakra UI', 'MongoDB'],
    liveUrl: 'https://client-todo-gamma.vercel.app/',
    frontendUrl: 'https://github.com/suiisharma/client-todo',
    backendUrl: 'https://github.com/suiisharma/todo-backend',
    previewGif: tasktonicGif
  },
  {
    title: 'Bloomroom',
    description: 'Django, PostgreSQL • Developed a distributed social platform for private discussions. • Implemented Django’s MVT architecture, reducing code complexity by 40% and improving performance by 25%. • Engineered secure sessions and cookies for seamless, private interaction.',
    technologies: ['Django', 'PostgreSQL'],
    backendUrl: 'https://github.com/suiisharma/Bloomroom',
    previewGif: bloomroomGif
  },
];







function App() {
  const { colorMode, toggleColorMode } = useColorMode();

  

  useEffect(() => {
    
  }, []);

  const bg = useColorModeValue('white', 'gray.700');
  const color = useColorModeValue('gray.700', 'white');

  return (
    <ChakraProvider >
      <Container maxW="container.md" p={4}>
        <Flex justifyContent="space-between" alignItems="center">
          <IconButton
            icon={colorMode === 'dark' ? <FaSun /> : <FaMoon />}
            isRound
            size="lg"
            onClick={toggleColorMode}
            aria-label="Toggle Dark Mode"
            position="fixed"
            top="1rem"
            right="1rem"
          />
        </Flex>
        <VStack spacing={8} align="stretch" mt="4rem">
          <Box textAlign="center" bg={bg} p={5} borderRadius="lg" boxShadow="md">
            <Image
              borderRadius="full"
              boxSize="200px"
              src="https://i.imghippo.com/files/yHMPt1724899321.jpg"
              alt="Profile Pic"
              m="auto"
            />
            <Heading as="h1" mt={4} color={color} animation="slideIn 2s ease-out">
              Sourav Sharma
            </Heading>
            <Text fontSize="xl" mt={2} color={color}>
               Full Stack Developer | Associate at Oracle | Web Developer
            </Text>
            <HStack justify="center" mt={4}>
              <Link href="https://github.com/suiisharma" isExternal>
                <IconButton icon={<FaGithub />} isRound size="lg" aria-label="GitHub" />
              </Link>
              <Link href="https://www.linkedin.com/in/sourav-sharma-646291222/" isExternal>
                <IconButton icon={<FaLinkedin />} isRound size="lg" aria-label="LinkedIn" />
              </Link>
              <Link href="mailto:sourav.sharma.engineer@gmail.com">
                <IconButton icon={<FaEnvelope />} isRound size="lg" aria-label="Email" />
              </Link>
              <Link href="tel:+91 78760 87442">
                <IconButton icon={<FaPhone />} isRound size="lg" aria-label="Phone" />
              </Link>
            </HStack>
          </Box>
          <Box p={5} bg={bg} borderRadius="lg" boxShadow="md">
            <GitHubCalendar username="suiisharma" />
          </Box>
          <Box  p={5} bg={bg} borderRadius="lg" boxShadow="md">
            <Heading as="h2" size="lg" color={color} textAlign={'center'}>
            My Tech Stack
            </Heading>
            <div style={{
              display: 'flex',
            }}>
            <AnimatedSkillIconBar  bg={bg} color={color}></AnimatedSkillIconBar>
            </div>
          </Box>
          <About bg={bg} color={color} />
          <Education bg={bg} color={color} />
          <Projects bg={bg} color={color} projects={projects} />
          <Resume bg={bg} color={color} />
          <Certifications bg={bg} color={color} />
          <Contact bg={bg} color={color} />
        </VStack>
      </Container>
      <Sidebar />
    </ChakraProvider>
  );
}

export default App;
